import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`numbers`, [`gap`]);
